import oidc from '@/vue-oidc-client';

const PMChart = () => import('@/pages/ProjectManagement/PMChart.vue');
const PMChartBpc = () => import('@/components/ProjectManagement/PMChartBpc.vue');
const PMVersionPage = () => import('@/pages/ProjectManagement/PMVersionPage.vue');
const PMChartCreateEdit = () => import('@/pages/ProjectManagement/PMChartCreateEdit.vue');
const PMChartInfo = () => import('@/components/ProjectManagement/PMChartInfo.vue');
const PMCharts = () => import('@/pages/ProjectManagement/PMCharts.vue');
const PMStructure = () => import('@/components/ProjectManagement/PMStructure.vue');
const PMChartDpcQuartPage = () => import('@/pages/ProjectManagement/PMChartDpcQuartPage.vue');
const PMChartDpcExecPage = () => import('@/pages/ProjectManagement/PMChartDpcExecPage.vue');
const PMChartDeadlinesPage = () => import('@/pages/ProjectManagement/PMChartDeadlinesPage.vue');
const PMChartComparePage = () => import('@/pages/ProjectManagement/PMChartComparePage.vue');

const WeeklyReportPage = () => import('@/pages/ProjectManagement/Reports/Weekly/WeeklyReportPage.vue');
const IntroductoryInformationPage = () =>
    import('@/pages/ProjectManagement/Reports/Weekly/IntroductoryInformationPage.vue');
const ConstructionProgressPage = () => import('@/pages/ProjectManagement/Reports/Weekly/СonstructionProgressPage.vue');
const TypeWorkPage = () => import('@/pages/ProjectManagement/Reports/Weekly/TypeWorkPage.vue');
const ChartsPage = () => import('@/pages/ProjectManagement/Reports/Weekly/ChartsPage.vue');

const DpcQuart = () => import('@/components/ProjectManagement/Report/DpcQuart.vue');
const DpcExec = () => import('@/components/ProjectManagement/Report/DpcExec.vue');
const WeeklyReport = () => import('@/components/ProjectManagement/Report/WeeklyReport.vue');
export default [
    {
        path: 'charts',
        name: 'projectManagement.charts',
        component: PMCharts,
        meta: { showSidebar: true },
    },
    {
        path: 'charts/create',
        name: 'projectManagement.charts.create',
        component: PMChartCreateEdit,
        meta: { showSidebar: true },
    },
    {
        path: 'charts/edit/:id',
        name: 'projectManagement.charts.edit',
        component: PMChartCreateEdit,
        props: true,
        meta: { showSidebar: true },
    },
    {
        path: 'charts/:id',
        component: PMChart,
        props: true,
        meta: {
            showSidebar: false,
            authName: oidc.authName,
        },
        children: [
            {
                path: '',
                redirect: (to: any) => ({
                    name: 'projectManagement.chart.info',
                    params: { id: to.params.id },
                }),
            },
            {
                path: 'info',
                name: 'projectManagement.chart.info',
                component: PMChartInfo,
                meta: { showSidebar: false },
            },
            {
                path: 'structure',
                name: 'projectManagement.chart.structure',
                component: PMStructure,
                meta: { showSidebar: false },
            },
            {
                path: 'bpc',
                name: 'projectManagement.chart.bpc',
                component: PMChartBpc,
                props: true,
                meta: { showSidebar: false },
            },
            {
                path: 'dpc-quart',
                name: 'projectManagement.chart.dpc-quart',
                component: DpcQuart,
                meta: { showSidebar: false },
            },
            {
                path: 'dpc-exec',
                name: 'projectManagement.chart.dpc-exec',
                component: DpcExec,
                meta: { showSidebar: false },
            },
            {
                path: 'weekly-report',
                name: 'projectManagement.chart.weekly-report',
                component: WeeklyReport,
                meta: { showSidebar: false },
            },
        ],
    },
    {
        path: 'charts/:id/dpc-quart/:docId',
        name: 'projectManagement.chart.dpc-quart.detail',
        component: PMChartDpcQuartPage,
        meta: {
            showSidebar: false,
        },
    },
    {
        path: 'charts/:id/dpc-quart/create',
        name: 'projectManagement.chart.dpc-quart.create',
        component: PMChartDpcQuartPage,
        meta: {
            showSidebar: false,
        },
    },
    {
        path: 'charts/:id/dpc-exec/:docId',
        name: 'projectManagement.chart.dpc-exec.detail',
        component: PMChartDpcExecPage,
        meta: {
            showSidebar: false,
        },
    },
    {
        path: 'charts/:id/dpc-exec/create',
        name: 'projectManagement.chart.dpc-exec.create',
        component: PMChartDpcExecPage,
        meta: {
            showSidebar: false,
        },
    },
    {
        path: 'charts/:id/weekly-report/:docId',
        component: WeeklyReportPage,
        children: [
            {
                path: '',
                name: 'projectManagement.chart.weekly-report.detail',
                component: IntroductoryInformationPage,
                meta: {
                    showSidebar: false,
                },
            },
            {
                path: 'constraction-progress',
                name: 'projectManagement.chart.weekly-report.progress',
                component: ConstructionProgressPage,
                meta: {
                    showSidebar: false,
                },
            },
            {
                path: 'type-works',
                name: 'projectManagement.chart.weekly-report.type-works',
                component: TypeWorkPage,
                meta: {
                    showSidebar: false,
                },
            },
            {
                path: 'charts',
                name: 'projectManagement.chart.weekly-report.charts',
                component: ChartsPage,
                meta: {
                    showSidebar: false,
                },
            },
        ],
        meta: {
            showSidebar: false,
        },
    },
    {
        path: 'charts/:id/weekly-report/create',
        name: 'projectManagement.chart.weekly-report.create',
        component: WeeklyReportPage,
        meta: {
            showSidebar: false,
        },
    },
    {
        path: 'chart/:id/version/:versionId',
        name: 'projectManagement.chart.version',
        component: PMVersionPage,
        props: true,
        meta: { showSidebar: false },
    },
    {
        path: 'chart/:id/report-deadline',
        name: 'projectManagement.chart.report-deadline',
        component: PMChartDeadlinesPage,
        meta: { showSidebar: false },
    },
    {
        path: 'chart/:id/compare/:versionId',
        name: 'projectManagement.chart.compare',
        component: PMChartComparePage,
        meta: { showSidebar: false },
    },
];
